import * as React from 'react';
import {PAGE_TYPE} from '../../Config/appConfig';

const coverNoteDefault = require('../../resource/img/covernote-default.svg');
const coverNoteFocused = require('../../resource/img/covernote-focused.svg');
const policyDefault = require('../../resource/img/policy-default.svg');
const policyFocused = require('../../resource/img/policy-focused.svg');
const archivedDefault = require('../../resource/img/archived-default.svg');
const archivedFocused = require('../../resource/img/archived-focused.svg');
const focusedBackground = require('../../resource/img/tab-focused.png');

interface RecordsBannerButtonProps {
    buttonType: string,
    count: string,
    isSelected: boolean,
    onClick: () => void
}

class RecordsBannerButton extends React.Component <RecordsBannerButtonProps, {}> {
    public constructor(props: RecordsBannerButtonProps) {
        super(props);
        this.clickBtn = this.clickBtn.bind(this);
    }

    public clickBtn(event: React.MouseEvent<HTMLElement>) {
        event.preventDefault();
        this.props.onClick();
    }

    public getResource() {
        let title = '';
        let banner = null;
        switch (this.props.buttonType) {
            case PAGE_TYPE.COVER_NOTE:
                title = 'Cover Note';
                banner = this.props.isSelected ? coverNoteFocused : coverNoteDefault;
                break;
            case PAGE_TYPE.POLICY:
                title = 'Policy';
                banner = this.props.isSelected ? policyFocused : policyDefault;
                break;
            case PAGE_TYPE.ARCHIVED:
                title = 'Archived';
                banner = this.props.isSelected ? archivedFocused : archivedDefault;
                break;
            default: break;
        }
        return {title, banner};
    }

    public render() {
        const resource = this.getResource();
        return (
            <button className={`recordsButton recordsBannerButton ${this.props.isSelected ? "recordsBannerButtonSelected" : "cmWhiteBtn recordsBannerButtonNotSelected"}`}
                    onClick={this.clickBtn}>
                {this.props.isSelected && <img src={focusedBackground}/>}
                <div className="cmBannerButtonContainer recordsBannerButtonContainer">
                    <img className="recordsBannerButtonIcon" src={resource.banner}/>
                    <div className="recordsBannerButtonInfo">
                        <div className="recordsBannerButtonCount">{this.props.count}</div>
                        <div className="cmBoldText recordsBannerButtonTitle">{resource.title}</div>
                    </div>
                </div>
            </button>
        );
    }
}

export default RecordsBannerButton;


// WEBPACK FOOTER //
// ./src/Components/Records/RecordsBannerButton.tsx